<script>
import ErrorModal from "@/components/confirmations/error.vue"
import FormSelect from "@/components/forms/FormSelect.vue"
import { client } from "@/main"
import { useAuthStore } from "@/store/modules/auth"
import { useTransformationFunctionsStore } from "@/store/modules/transformationFunctions"

export default {
  name: "DataFlowDiagramTransformation",
  components: { FormSelect, ErrorModal },

  emits: ["change", "updated"],
  props: {
    isActive: {
      type: Boolean,
      required: true
    },
    dataFlow: {
      type: Object,
      required: true
    }
  },
  setup() {
    const authStore = useAuthStore()
    const tfStore = useTransformationFunctionsStore()

    return { authStore, tfStore }
  },
  data: () => ({
    isKebabOpened: false,
    openedBoxes: [],
    selectedTransformation: null,
    transformationList: [],
    editedTransform: {},
    errors: "",
    errorsToTranslate: [],
    openedTransformConfirmation: false,
    openedTransformEdit: false,
    isErrorOpen: false,
    transformationsLoaded: false
  }),
  created() {
    this.loadTransformationfunctions()
  },
  watch: {
    "dataFlow.transformationId": {
      handler(transformationId) {
        if (!transformationId) {
          this.selectedTransformation = null
        }
      }
    },
    transformationList: {
      handler(tfList) {
        this.selectedTransformation = tfList.find((t) => t.transformationId === this.dataFlow.transformationId)
      },
      immediate: true
    },
    dataFlow() {
      this.loadTransformationfunctions()
    }
  },
  methods: {
    copyToClipboard() {
      navigator.clipboard.writeText(this.selectedTransformation?.definition || "")
    },
    handleRemoveTransform() {
      this.$emit("change", null)
      this.selectedTransformation = null
      this.isKebabOpened = false
    },
    handleTransformationChanged(transformation) {
      this.selectedTransformation = transformation
      this.$emit("change", transformation.transformationId)
    },
    async loadTransformationfunctions() {
      if (!this.dataFlow.technology) {
        return
      }

      const params = {
        "type[eq]": "DATAFLOW",
        "sort[eq]": "label",
        "subType[eq]": this.dataFlow.technology
      }

      const projectTransformations = await client.path("/transformations").method("get").create()({
        ...params,
        "projectId[eq]": this.$route.params.projectId
      })
      const publicTransformations = await client.path("/transformations").method("get").create()({
        ...params,
        "public[eq]": true
      })
      this.transformationList = [...projectTransformations.data.data, ...publicTransformations.data.data]
      this.transformationsLoaded = true
    }
  }
}
</script>

<template>
  <div :class="{ 'data-flow-diagram__box--inactive': !isActive }" class="data-flow-diagram__box">
    <div class="data-flow-diagram__box__header">
      {{ $t("TRANSFORMATION_FUNCTION") }}
    </div>
    <div
      v-if="dataFlow.technology && transformationsLoaded"
      :style="!dataFlow.transformationId ? 'padding-top: 1rem' : ''"
    >
      <FormSelect
        :class="{ 'mt-5': !selectedTransformation?.description }"
        :has-error="false"
        item-text="label"
        item-value="transformationId"
        item-subtext="description"
        subtext-font-size="12px"
        :items="transformationList ?? []"
        :placeholder="$t('noTransformFunction')"
        label=""
        clearable
        :value="transformationList?.find((tf) => tf.transformationId === selectedTransformation?.transformationId)"
        @change="handleTransformationChanged"
        @clear="handleRemoveTransform"
      />
    </div>
    <!--    <div v-if="selectedTransformation && selectedTransformation.transformationId">-->
    <!--      <div class="data-flow-diagram__box__option">-->
    <!--        <div class="d-flex justify-content-between">-->
    <!--          <div class="data-flow-diagram__box__option__header">-->
    <!--            <h6 class="mb-0">-->
    <!--              {{ selectedTransformation.label }}-->
    <!--            </h6>-->
    <!--          </div>-->

    <!--          <div class="dropdown-actions">-->
    <!--            <div class="atom-icon d-block mr-0" @click="isKebabOpened = true">-->
    <!--              <img alt="" height="32" src="@/assets/icons/menu/ico-kebab.svg" />-->
    <!--            </div>-->
    <!--            <div-->
    <!--              v-if="isKebabOpened"-->
    <!--              v-click-outside="-->
    <!--                () => {-->
    <!--                  isKebabOpened = false-->
    <!--                }-->
    <!--              "-->
    <!--              class="dropdown-actions__wrapper"-->
    <!--            >-->
    <!--              <div class="dropdown-actions__inner">-->
    <!--                <div class="dropdown-actions__item d-flex align-items-center" @click="handleRemoveTransform">-->
    <!--                  <div class="atom-icon">-->
    <!--                    <img alt="" src="@/assets/icons/ico-upravitzarizeni.svg" />-->
    <!--                  </div>-->
    <!--                  {{ $t("CHANGE") }}-->
    <!--                </div>-->
    <!--              </div>-->
    <!--            </div>-->
    <!--          </div>-->
    <!--        </div>-->
    <!--        <div v-if="selectedTransformation.description">-->
    <!--          {{ selectedTransformation.description }}-->
    <!--        </div>-->
    <!--      </div>-->
    <!--    </div>-->

    <ErrorModal :centered="true" :errors="errorsToTranslate" :opened="isErrorOpen" @close="isErrorOpen = false" />
  </div>
</template>
